import apiClient from "./apiClient";

export const DISTRICT_UPDATE_SUPPORTED = true;

export const getDistricts = async (params = {}) => {
  const response = await apiClient.get("/api/districts", { params });
  return response.data?.districts || response.data?.data || response.data || [];
};

export const getDistrictById = async (districtId) => {
  const response = await apiClient.get(`/api/districts/${districtId}`);
  return response.data?.district || response.data?.data || response.data || null;
};

export const createDistrict = async (payload) => {
  const response = await apiClient.post("/api/districts", payload);
  return response.data;
};

export const updateDistrict = async (districtId, payload) => {
  const response = await apiClient.put(`/api/districts/${districtId}`, payload);
  return response.data;
};
